import script from "./TaxDeductionRequestDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxDeductionRequestDialog.vue?vue&type=script&setup=true&lang=js"

import "./TaxDeductionRequestDialog.vue?vue&type=style&index=0&id=50ebef32&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ebef32"]])

export default __exports__